<script lang="ts" context="module">
  // eslint-disable-next-line no-shadow
  export enum Level {
    H1 = 1,
    H2,
    H3,
    H4,
    H5,
    H6,
  }
</script>

<script lang="ts">
  export let level: Level = Level.H1

  let className = ''
  export { className as class }

  export let href: string | undefined = undefined

  // Used for control DOM element from outside
  export let forwardRef: HTMLHeadingElement | undefined = undefined
  export let forwardAction: any = () => {}
</script>

<template lang="pug">
  include ./template.pug
</template>
